// extracted by mini-css-extract-plugin
export default {"container":"WebImpressumScreen_container__ucBsh","gaplessBox":"WebImpressumScreen_gaplessBox__JRCOL"};